/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PncSearchCriteriaModel} from './pnc-search-criteria.model';
import {PartNumberChangeSearchCriteriaContract} from '../../../api/ms-partnumberchanges/contracts/part-number-change-search-criteria.contract';


export class PncSearchCriteriaMapper {
    private constructor() {
    }

    static toPncSearchCriteriaContract(input: PncSearchCriteriaModel): PartNumberChangeSearchCriteriaContract {
        let criteria: PartNumberChangeSearchCriteriaContract = null;
        if (input != null) {
            criteria = {
                typeCodes: input.typeCodes,
                number: input.number,
                creationDatetime: input.creationDatetime,
                partnerCodes: input.partnerCodes,
                updatedBy: input.updatedBy,
                changedOn: input.changedOn,
                oldMaterialNumber: input.oldMaterialNumber,
                statusCodes: input.statusCodes,
                newMaterialNumber: input.newMaterialNumber,
                technicianGroupCodes: input.technicianGroupCodes,
                createdBy: input.createdBy,
                supplyingPackingPlantCodes: input.supplyingPackingPlantCodes,
                done: input.done
            };
        }
        return criteria;
    }
}
